import { ReactNode, createContext, useContext } from "react"

const SelectListGroupContext = createContext<true | null>(null)

SelectListGroupContext.displayName = "SelectListGroupContext"

export function SelectListGroupProvider({ children }: { children: ReactNode }) {
    return <SelectListGroupContext.Provider value={true}>{children}</SelectListGroupContext.Provider>
}

export function useSelectListGroupContext() {
    const context = useContext(SelectListGroupContext)
    if (!context) {
        throw new Error("Select.ListItem must be used within a Select.ListGroup")
    }
    return context
}
